var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Icon, toast } from '@a-type/ui';
import { useNavigate } from '@tanstack/react-router';
import { useContext } from 'react';
import { VerdantContext } from '../verdant.js';
export function EntityDeleteButton(_a) {
    var { entity, redirectTo, children, entityName = 'Item', onClick } = _a, rest = __rest(_a, ["entity", "redirectTo", "children", "entityName", "onClick"]);
    const navigate = useNavigate();
    const client = useContext(VerdantContext);
    return (_jsx(Button, Object.assign({ emphasis: "primary", color: "attention" }, rest, { onClick: (ev) => {
            entity.deleteSelf();
            if (redirectTo) {
                navigate({ to: redirectTo });
            }
            const id = toast(_jsxs(Box, { gap: true, items: "center", children: [_jsxs("span", { children: [entityName, " deleted"] }), _jsx(Button, { size: "small", onClick: () => {
                            if (client) {
                                client.undoHistory.undo();
                                toast.close(id);
                                toast(`Restored ${entityName}`, {
                                    duration: 5000,
                                });
                            }
                            else {
                                toast.error('Could not restore item');
                            }
                        }, children: "Undo" })] }), {
                duration: 10000,
            });
            onClick === null || onClick === void 0 ? void 0 : onClick(ev);
        }, children: children || (_jsxs(_Fragment, { children: [_jsx(Icon, { name: "trash" }), _jsxs("span", { children: ["Delete ", entityName] })] })) })));
}
//# sourceMappingURL=EntityDeleteButton.js.map